import React, { useState } from "react";
import "./Testimonials.css";
import Common_Heading from "../common_components/common_Heading/Common_Heading";
import Common_breadcrumb from "../common_components/common_breadcrumb/Common_breadcrumb";
import Testimonials_card from "./testimonials_card/Testimonials_card";
import Purple_border_btn from "../common_components/common_btn/purple_border_btn/Purple_border_btn";
import Purple_Btn from "../common_components/common_btn/purple_btn/Purple_Btn";

function Testimonials() {
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "TESTIMONIALS" },
  ];

  // ✅ Dummy Testimonials Data (you can replace with API later)
  const testimonialsData = [
    { id: 1 },
    { id: 2 },
    { id: 3 },
    { id: 4 },
    { id: 5 },
    { id: 6 },
    { id: 7 },
    { id: 8 },
    { id: 9 },
    { id: 10 },
    { id: 11 },
    { id: 12 },
  ];

  // ✅ Pagination
  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(testimonialsData.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentTestimonials = testimonialsData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <>
      <section className="Testimonials">
        <div className="custom_container">
          <Common_breadcrumb items={breadcrumbItems} />

          <Common_Heading
            headingText={"CUSTOMERS' LOVE FOR US"}
            subHeadingText={
              "Voices of delight: our customers share their stories!"
            }
          />

          <div className="banner_img_holder">
            <img
              src="/assest/luxury_images/testimonials/banner.png"
              alt="testimonials banner img"
              className="banner_img"
            />
          </div>

          <div className="Testimonials_cards_holder">
            <div className="row justify-content-center">
              <div className="col-xl-7 col-md-9">
                {currentTestimonials.map((item) => (
                  <Testimonials_card key={item.id} />
                ))}
              </div>
            </div>
          </div>

          {/* ✅ Pagination Buttons */}
          <div className="btn_holder">
            <div>
              <Purple_border_btn
                btnText="Previous Page"
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              />
            </div>

            <div>
              <Purple_Btn
                btnText="Next Page"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              />
            </div>
          </div>

          {/* Optional Page Number */}
          <div className="page_count_text">
            Page {currentPage} of {totalPages}
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
